<template>
  <div class="SearchBar">
    <div class="row">
      <div class="col">
        <div class="input-group d-flex justify-content-center">
          <!-- SourceFieldManager select options -->
          <select
            v-if="filename == 'SourceFieldManager'"
            class="form-select w-25 my-2 mr-sm-2"
            v-model="searchBy"
            @input="changeSearchSelection"
            style="max-width: 150px"
          >
            <option selected value="source_field">Source Field</option>
            <option value="description">Description</option>
            <option value="type">Type</option>
          </select>
          <!-- EditRuleset select options -->
          <select
            v-if="filename == 'EditRuleset'"
            class="form-select w-25 my-2 mr-sm-2"
            v-model="searchBy"
            @input="changeSearchSelection"
            style="max-width: 150px"
          >
            <option selected value="rule_type">Rule Type</option>
            <option value="source_field">Source Field</option>
            <option value="result">Result</option>
          </select>
          <input
            class="form-control my-2 mr-sm-2"
            style="max-width: 500px"
            type="search"
            v-model="searchString"
            @input="debounceSearch"
            placeholder="Search"
            aria-label="Search"
          />
          <button
            @click="searchStringUpdated"
            class="btn my-2 my-sm-2"
            id="search-icon"
            type="submit"
          >
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    sourcefields: Array,
    filename: String,
    defaultSearchBy: String,
    reverseSort: String,
  },
  data() {
    return {
      sourcefieldsFiltered: {},
      searchString: null,
      searchBy: this.defaultSearchBy,
      resetPageStartAndActivePageNumber: true,
      debounce: null,
    };
  },
  emits: ["updateValuesFromSearchBar"],
  methods: {
    changeSearchSelection() {
      if (this.searchString != "" && this.searchString != null) {
        this.debounceSearch(true);
      }
    },
    debounceSearch(instantSearch) {
      // Reset search immediately if the searchbar is empty
      if (this.searchString == "" || instantSearch == true) {
        this.searchStringUpdated();
      }
      // Otherwise, debounce
      clearTimeout(this.debounce);
      // console.log("debounce started");
      this.debounce = setTimeout(() => {
        // console.log("debounce done");
        this.searchStringUpdated();
      }, 500);
    },
    // Reset is an optional parameter, doesn't matter variable
    searchStringUpdated(stayOnActivePage) {
      if (this.searchString == "" || this.searchString == null) {
        this.sourcefieldsFiltered = this.sourcefields;
        this.resetPageStartAndActivePageNumber = true;
        this.searchString = null;
      } else {
        // Reset pageStart and activePageNumber
        // this.resetPageStartAndActivePageNumber = stopReset ? false : true;
        this.resetPageStartAndActivePageNumber = true;
        if (this.filename == "SourceFieldManager") {
          // Make sure that sourcefields change updates sourcefieldsSearchFiltered
          if (this.searchBy == "description") {
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              return item.description
                .toLowerCase()
                .includes(this.searchString.toLowerCase());
            });
          } else if (this.searchBy == "source_field") {
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              return item.source_field
                .toLowerCase()
                .includes(this.searchString.toLowerCase());
            });
          } else {
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              return item.type
                .toLowerCase()
                .includes(this.searchString.toLowerCase());
            });
          }
        } else {
          // Code for only searching the sourcefields
          // this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
          //   // console.log(item.source_fields);
          //   // Boolean on whether to include: if any element contains the input as a substring
          //   return item.source_fields.every((source) =>
          //     source.toLowerCase().includes(this.searchString.toLowerCase())
          //       ? true
          //       : false
          //   );
          // });
          // Code for searching the sourcefields, rule type, and output/result
          if (this.searchBy == "source_field") {
            // Here, filename == editRuleset
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              // console.log(item.source_fields);
              // Return a boolean on whether to include: if any element contains the input as a substring
              return item.source_fields.some((source) =>
                source.toLowerCase().includes(this.searchString.toLowerCase())
                  ? true
                  : false
              );
            });
          } else if (this.searchBy == "rule_type") {
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              return item.rule_type
                .toLowerCase()
                .includes(this.searchString.toLowerCase());
            });
          } else {
            // This is the Output/Result from the page, which is the decline_message in the data
            this.sourcefieldsFiltered = this.sourcefields.filter((item) => {
              if (item.rule_type == "map" || item.rule_type == "function") {
                return item.calculator_param == null
                  ? item.custom_field
                      .toLowerCase()
                      .includes(this.searchString.toLowerCase())
                  : item.calculator_param
                      .toLowerCase()
                      .includes(this.searchString.toLowerCase());
              } else if (item.rule_type == "passthru") {
                if (item.calculator_param) {
                  return item.calculator_param
                    .toLowerCase()
                    .includes(this.searchString.toLowerCase());
                } else if (item.custom_field) {
                  return item.custom_field
                    .toLowerCase()
                    .includes(this.searchString.toLowerCase());
                } else {
                  window.alert(
                    "One or more passthru functions are missing an output value."
                  );
                }
              } else {
                return item.decline_message
                  .toLowerCase()
                  .includes(this.searchString.toLowerCase());
              }
              // return item.rule_type == "map" || item.rule_type == "function"
              //   ? // Look through calculator_param or custom_field for map and function type rules
              //     item.calculator_param == null
              //     ? item.custom_field
              //         .toLowerCase()
              //         .includes(this.searchString.toLowerCase())
              //     : item.calculator_param
              //         .toLowerCase()
              //         .includes(this.searchString.toLowerCase())
              //   : item.decline_message
              //       .toLowerCase()
              //       .includes(this.searchString.toLowerCase());
              // return item.decline_message
              //   .toLowerCase()
              //   .includes(this.searchString.toLowerCase());
            });
          }
        }
      }
      // Value passed in from rules watch in EditRuleset
      this.resetPageStartAndActivePageNumber = stayOnActivePage
        ? false
        : this.resetPageStartAndActivePageNumber;
      this.$emit(
        "updateValuesFromSearchBar",
        this.sourcefieldsFiltered,
        this.resetPageStartAndActivePageNumber
      );
    },
  },
};
</script>

<style>
#search-icon {
  color: rgb(0, 183, 255);
  border: 2px solid rgb(0, 183, 255);
}

#search-icon:hover {
  color: white;
  background-color: rgb(0, 183, 255);
}
</style>
